// src/pages/StatusAnalyticsPage.js
import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import useAuth from '../../hooks/useAuth';
import api from '../../services/api';

const StatusAnalyticsPage = () => {
    const { projects, user } = useAuth();
    const [analytics, setAnalytics] = useState([]);
    const [loading, setLoading] = useState(true);
    const [availableProjects, setAvailableProjects] = useState([]);
    const [selectedProject, setSelectedProject] = useState('0');

    useEffect(() => {
      if (!user) return;

      const fetchAllData = async () => {
        try {
          const res = await api.get('/status_analytics', {
            params: { project: selectedProject }
          });
          const data = res.data?.data;
          const projectsData = res.data?.projects;
          
          if (Array.isArray(data)) {
            setAnalytics(data);
          } else {
            console.warn('Неверный формат данных:', res.data);
            setAnalytics([]);
          }
          
          if (Array.isArray(projectsData)) {
            setAvailableProjects(projectsData);
          }
        } catch (err){
          console.error('Ошибка загрузки проектов:', err);
          setAnalytics([]);
          setAvailableProjects([]);
        } finally {
          setLoading(false);
        }
      };
      fetchAllData();
    }, [user, selectedProject]);

    const handleProjectChange = (e) => {
      setSelectedProject(e.target.value);
    };

    return (
        <div className="main-content">
          <h1>Статус аналитики</h1>
          <div className="mb-3">
            <label htmlFor="projectSelect" className="form-label">Проект</label>
            <select
              className="form-select"
              id="projectSelect"
              value={selectedProject}
              onChange={handleProjectChange}
            >
              {availableProjects.map((project) => (
                <option key={project.id} value={project.id}>
                  {project.name}
                </option>
              ))}
            </select>
          </div>
          {loading ? (
            <div className="p-4">Загрузка аналитики...</div>
          ) : analytics.length === 0 ? (
            <div className="p-4">Нет данных для отображения</div>
          ) : (
            <table className="table table-bordered table-striped-columns mt-4">
              <thead>
                <tr>
                  <th>Проект</th>
                  <th>Дата аналитики</th>
                  <th>До часа</th>
                  <th>Количество звонков</th>
                  <th>Время звонков</th>
                  <th>Дата загрузки звонков</th>
                  <th>Время загрузки</th>
                  <th>Дата перевода в текст</th>
                  <th>Время перевода в текст</th>
                  <th>Дата анализа звонков</th>
                  <th>Время анализа</th>
                </tr>
              </thead>
              <tbody>
                {analytics.map((item, index) => (
                  <tr key={index}>
                    <td>{item.project}</td>
                    <td>{item.date}</td>
                    <td>{ item.hour_end !== 0 ? item.hour_end : 24}</td>
                    <td>{item.total_records}</td>
                    <td>{item.duration}</td>
                    <td>{item.datetime_update_load}</td>
                    <td>{item.duration_load}</td>
                    <td>{item.datetime_update_sound_for_text}</td>
                    <td>{item.duration_sound_for_text}</td>
                    <td>{item.datetime_update_analytics_phrase}</td>
                    <td>{item.duration_analytics_phrase}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
    )
};

export default StatusAnalyticsPage;